import React from 'react';
import { images } from '../../utils/assetHelpers';
import MaterialIcon from '../MaterialIcon';

const Hero = ({ setIsModalOpen }) => {
  return (
    <section className="relative overflow-hidden mt-16 overflow-guard">
      {/* 多层渐变背景 */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#F1F600] via-[#F1F600]/95 to-[#FFB302]">
          <div className="absolute inset-0 bg-gradient-to-tl from-[#2C3E50]/30 via-transparent to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-transparent via-[#FF4D4D]/10 to-[#FF4D4D]/20"></div>
        </div>
        
        {/* 动态流动背景元素 - 限制尺寸避免溢出 */}
        <div className="absolute top-1/4 right-0 max-w-[80vw] md:max-w-[800px] aspect-square bg-[#F1F600]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute top-1/3 left-0 max-w-[80vw] md:max-w-[700px] aspect-square bg-[#FF4D4D]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-1/4 left-1/2 max-w-[70vw] md:max-w-[600px] aspect-square bg-[#2C3E50]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>
      
      {/* 装饰性背景元素 */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-2/3 h-full bg-gradient-to-l from-[#2C3E50]/10 via-[#2C3E50]/5 to-transparent rounded-l-[200px] transform -skew-x-12"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-2/3 bg-gradient-to-t from-[#FF4D4D]/10 via-[#FF4D4D]/5 to-transparent rounded-tr-[150px]"></div>
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-gradient-to-br from-[#F1F600] to-[#FFB302] rounded-full blur-2xl opacity-30"></div>
        <div className="absolute bottom-1/4 right-1/4 w-40 h-40 bg-gradient-to-br from-[#FF4D4D] to-[#FFB302] rounded-full blur-3xl opacity-20"></div>
      </div>
      
      <div className="relative container-wide flex items-center">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 py-12 md:py-16 lg:py-12">
          {/* 左侧内容区 */}
          <div className="space-y-6 md:space-y-8 lg:space-y-10 xl:space-y-12 lg:pr-8 flex flex-col justify-center h-full">
            <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-gradient-to-r from-[#2C3E50]/20 to-[#2C3E50]/10 backdrop-blur-sm border border-white/20">
              <MaterialIcon icon="verified" className="text-[#2C3E50] text-xl" />
              <p className="text-[#2C3E50] font-medium lg:text-lg xl:text-xl">国内首家专注于教练服务的平台</p>
            </div>
            
            <div className="space-y-2 md:space-y-4">
              <h1 className="text-[#2C3E50] text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight tracking-tight">
                看见<span className="relative inline-block group cursor-pointer">
                  <span className="relative z-10 text-[#FF4D4D] transform group-hover:scale-110 transition-transform duration-300">真问题</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#FF4D4D]/20 to-[#FFB302]/20 blur-xl transform scale-150 group-hover:scale-200 transition-all duration-500"></div>
                  <div className="absolute -inset-2 bg-[#FF4D4D]/10 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute -inset-4 bg-[#FFB302]/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                </span>
              </h1>
              <h1 className="text-[#2C3E50] text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight tracking-tight">
                创业少吃<span className="relative inline-block group cursor-pointer">
                  <span className="relative z-10 text-[#FF4D4D] transform group-hover:scale-110 transition-transform duration-300">苦</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#FF4D4D]/20 to-[#FFB302]/20 blur-xl transform scale-150 group-hover:scale-200 transition-all duration-500"></div>
                  <div className="absolute -inset-2 bg-[#FF4D4D]/10 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute -inset-4 bg-[#FFB302]/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                </span>
              </h1>
            </div>
            
            <p className="text-[#2C3E50] text-base md:text-lg lg:text-xl xl:text-2xl leading-relaxed max-w-2xl">
              我们甄选了华语教练界的顶尖商业教练，在国际教练认证的基础上，特别强调商业实战经验和辅导效果。从创始人的商业决策、战略规划到企业中高层的团队赋能，深入组织各个层级，助力企业从0到1、1到10的跨越式发展。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 pt-4 sm:pt-6">
              <button 
                onClick={() => setIsModalOpen(true)}
                className="group relative px-6 py-3 md:px-8 md:py-4 xl:px-10 xl:py-5 rounded-full text-base md:text-lg xl:text-xl font-medium overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#2C3E50] to-[#2C3E50] transition-transform duration-300 group-hover:scale-105"></div>
                <span className="relative z-10 flex items-center justify-center text-white">
                  联系平台顾问
                <MaterialIcon icon="arrow_forward" className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
                </span>
              </button>
              <button 
                onClick={() => document.getElementById('products-section').scrollIntoView({ behavior: 'smooth' })}
                className="group relative px-6 py-3 md:px-8 md:py-4 xl:px-10 xl:py-5 rounded-full text-base md:text-lg xl:text-xl font-medium overflow-hidden border-2 border-[#2C3E50] hover:border-[#2C3E50]/70 transition-all duration-300"
              >
                <div className="absolute inset-0 bg-[#2C3E50]/5 rounded-full transition-all duration-300 group-hover:bg-[#2C3E50]/10"></div>
                <span className="relative z-10 flex items-center justify-center text-[#2C3E50]">
                  了解产品
                <MaterialIcon icon="arrow_forward" className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
                </span>
              </button>
            </div>
          </div>

          {/* 右侧图片区 */}
          <div className="relative hidden lg:flex items-center justify-center p-4 lg:p-6 xl:p-8">
            <div className="absolute inset-4 lg:inset-6 xl:inset-8 bg-gradient-to-br from-[#2C3E50]/5 to-[#FF4D4D]/5 rounded-3xl transform rotate-6"></div>
            <div className="relative w-full aspect-square rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src={images.conscious} 
                alt="专业教练服务" 
                className="w-full h-full object-cover"
              />
              {/* 图片蒙版效果 */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C3E50]/40 via-transparent to-transparent">
              </div>
            </div>
            {/* 装饰性元素 */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-[#F1F600] to-[#FFB302] rounded-full opacity-40 blur-2xl"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-gradient-to-br from-[#FF4D4D] to-[#FFB302] rounded-full opacity-30 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 
